import { ListItem, ListItemText } from "@mui/material";

export const NoInfo = () => {
  return (
    <ListItem sx={{ pl: 4 }}>
      <ListItemText>Nothing</ListItemText>
    </ListItem>
  );
};
